import scrollToElement from 'scroll-to-element';

/**
 * Footer
 * @var footer
 */
export default class Footer {
  /**
   * Constructor
   */
  constructor() {
    this.scrollTop = document.querySelector('.footer__go-top');
  }

  /**
   * Init
   */
  init() {
    this.handleClick();
  }

  /**
   * Handle Click
   */
  handleClick() {
    this.scrollTop.addEventListener('click', e => {
      e.preventDefault();
      Footer.scrollToTop();
    });
  }

  /**
   * Scroll to top
   */
  static scrollToTop() {
    scrollToElement('body', {
      ease: 'out-expo',
      duration: 1500,
    });
  }
}
